function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M21 9l.012.001.055-.001a8 8 0 017.996 7.75l.004.25a8 8 0 01-15.76 1.95A.943.943 0 0113 19H9a1 1 0 110-2h4l.066.003A7.987 7.987 0 0115.776 11H8a1 1 0 110-2h13zm.067 2a6 6 0 100 12 6 6 0 000-12zM11 13a1 1 0 110 2H4a1 1 0 110-2h7z",
  fill: "#000",
  fillRule: "evenodd"
});

function SvgIcAnimations(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _ref);
}

export default SvgIcAnimations;